import "./App.css";

function App() {
  return <div className="App">Hello from local World</div>;
}

export default App;
